import React from "react";
import MainContent from "../../../../widgets/templates/main_content";
import Table from "./table";
import { paths } from "../../../app_modules";
import AdminHeader from "../../../../widgets/templates/admin_header";

function StudentPage() {
  return (
    <MainContent>
      <AdminHeader
        title="Estudiantes"
        masivPath={paths.student_form}
        createPath={paths.student_form}
      />
      <hr />
      <div style={{ width: "100%" }}>
        <Table />
      </div>
    </MainContent>
  );
}

export default StudentPage;
